module.exports = {"id":"200724","name":"Nacho Fernández","rating":"81","photo":"./data/images/photos/2/200724.png","club":{"name":"Real Madrid","logo":"./data/images/clubs/RealMadrid.png"},"positions":["DC","DG","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NachoFernandez0.json
// module id = 3119
// module chunks = 0